<div class="container-fluid">
  <div class="row">
    <div class="col-12 d-flex flex-row-reverse" id="login-page">
      <div class="row">
        <div id="formContent">
          <img src="../../../assets/img/main-logo.png" alt="" >
          <!-- Login Form -->
          <form name="form-signin" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate style="width: 400px;">
            @if (errorMessage) {
              <div class="alert alert-danger" role="alert">{{errorMessage}}</div>
            }
            <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
              <input type="text" class="form-control input-text-custom"
                id="username" name="username" [(ngModel)]="user.username"
                placeholder="Username"
                #username="ngModel" required/>
                @if (f.submitted && !username.valid) {
                  <div class="help-block" translate>login.username_required</div>
                }
              </div>
              <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
                <div class="relative">
                  <input [type]="eyeOpened ? 'text' : 'password'"
                    class="passwordEyeInput form-control input-text-custom"
                    id="password"
                    name="password"
                    [(ngModel)]="user.password"
                    #password="ngModel"
                    required
                    placeholder="Password"
                    />
                    <label for="password" class="passwordEye">
                      @if (user.password.length) {
                        <img
                          (mousedown)="toggleEyeOpened($event, true)"
                          (mouseup)="toggleEyeOpened($event, false)"
                          (mouseleave)="toggleEyeOpened($event, false)"
                          src="/assets/img/eye.svg"
                          alt="eye"
                          draggable="false"
                          >
                      }
                    </label>
                  </div>
                  @if (f.submitted && !password.valid) {
                    <div class="help-block" translate>login.password_required</div>
                  }
                </div>
                <input type="submit" class="fadeIn fourth float-end" value="{{'login.button' | translate}}">
              </form>

              <!-- Remind Password -->
              <div id="formFooter">
                <a class="underlineHover text-white-shadow" [routerLink]="['/forgot-Password']" translate>login.forgot_password</a>
              </div>
            </div>

          </div>
          <app-footer></app-footer>
        </div>
      </div>
    </div>
